import { QuoteStatus } from '../enums/quoteStatus'

export const convertibleQuoteStatuses: QuoteStatus[] = [
  QuoteStatus.Accepted,
  QuoteStatus.Created,
  QuoteStatus.Open,
  QuoteStatus.Sent,
  QuoteStatus.Unsent,
]
